import { render, staticRenderFns } from "./SpecialMaterials.vue?vue&type=template&id=baebe34a&"
import script from "./SpecialMaterials.vue?vue&type=script&lang=js&"
export * from "./SpecialMaterials.vue?vue&type=script&lang=js&"
import style0 from "./SpecialMaterials.vue?vue&type=style&index=0&id=baebe34a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports